<template>
  <b-dropdown right variant="link" :menu-class="'dropdown-custom__menu fade'"
              toggle-class="" class="dropdown-custom dropdown-custom--main"
              no-caret>
    <template #button-content>
      <div class="fries">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </template>
    <template v-for="(item, index) in menuItems">
      <b-dropdown-item :to="{ name: item.route}" :key="index" v-if="item.route">
        <span class="d-flex justify-content-between">
          <span>{{ $t(item.name) }}</span> <span v-if="item.extra" class="extra">{{ item.extra }}</span>
        </span>
      </b-dropdown-item>
      <b-dropdown-divider v-if="item.divider" :key="index"></b-dropdown-divider>
      <b-dropdown-item href="#" @click.prevent="item.action" v-if="item.action" :key="index">
        {{ $t(item.name) }}
      </b-dropdown-item>
      <component :is="item.component" v-if="item.component" :key="index"/>
    </template>

    <template v-if="isPicaThirdLevelDomain">
      <a :href="B2BUrl" target="_blank" class="d-block item-business">
        <div class="d-flex align-items-center justify-content-between mb-2" style="gap: 8px">
          <div class="d-flex align-items-center" style="gap: 10px">
            <img :src="picaIcon" alt="GetPica Business" style="width: 20px;">
            <span class="font-weight-medium">{{ $t('menu.discover_pica') }}</span>
          </div>
          <Icon name="linkExternal" width="16" class="ml-1"/>
        </div>
        <div class="small">{{ $t('menu.discover_pica_text') }}</div>
      </a>

    </template>
  </b-dropdown>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {getB2BUrl, metricB2B} from "@/utils";
import ImpersonateLink from "@/domain/impersonate/ImpersonateLink.vue";
import picaIcon from "@/assets/pica-icon.svg";

export default {
  name: "MainMenu",
  components: {ImpersonateLink},
  computed: {
    ...mapGetters(['isPicaThirdLevelDomain']),
    ...mapGetters('auth', [
      'currentUser',
      'isAnonymous'
    ]),
    picaIcon() {
      return picaIcon
    },
    B2BUrl() {
      return this.getB2BUrl(metricB2B.MENU, 'request-demo')
    },
    menuItems() {
      return [
        {name: 'menu.checkins_list', route: 'checkins-list'},
        {name: 'menu.do_checkin', action: () => this.$bvModal.show('bv-modal-checkin-maker')},
        {divider: true},
        {name: 'menu.account', route: 'profile-resume', extra: this.currentUser.email, visible: !this.isAnonymous},
        {name: 'menu.privacy_settings', route: 'profile-privacy', visible: !this.isAnonymous},
        {name: 'menu.password_change', route: 'profile-change-password', visible: !this.isAnonymous},
        {name: 'menu.impersonate', component: 'ImpersonateLink'},
        {name: 'menu.logout', action: () => this.onLogout()},
      ].filter(item => item.visible !== false)
    }

  },
  methods: {
    getB2BUrl,
    ...mapActions('auth', ['logout']),

    async onLogout() {
      await this.logout()
      await this.$router.push('/')
    }
  }
}
</script>